import actionTypes from '../constants/action-types';

const setMainLocale = (locale) => ({
  type: actionTypes.SET_MAIN_LOCALE,
  payload: { locale },
});

export default setMainLocale;
